import { actionsFactory, props } from '@ngneat/effects';
import { AuthenticatedUser } from '@tmx/data-access';

import { FeatureFlagMap } from '../../models/feature-flags';

const featureFlagsActions = actionsFactory('feature-flags');

export const initFlagsmith = featureFlagsActions.create(
  'Initialize Flagsmith',
  props<{ user: AuthenticatedUser }>()
);

export const setUserFeatureFlags = featureFlagsActions.create(
  'Set User Feature Flags',
  props<{ featureFlags: FeatureFlagMap }>()
);

export const setFeatureFlagsInitialized = featureFlagsActions.create(
  'Set Feature Flags Initialized',
  props<{ featureFlagsInitialized: boolean }>()
);

export const resetFeatureFlags = featureFlagsActions.create(
  'Reset Feature Flags'
);

export const setFlagsmithUserTrait = featureFlagsActions.create(
  'Set Flagsmith User Trait',
  props<{ key: string; value: string }>()
);
